import staticData from "@/public/data/flight/passengers.json";
import { SealCheck } from "@phosphor-icons/react/dist/ssr";
import Typography from "@/shared/components/common/Typography";
import Flex from "@/shared/components/common/Flex";
import { Button } from "@/shared/components/common/button";
import { Pulse } from "@/shared/components/common/Animations";
import { useSearchParams } from "next/navigation";
import { cn } from "@/shared/libs/commonUtils";
import InfoCard from "@/containers/components/cards/infoCard/InfoCard";

interface SubmitCardProps {
  totalPrice: number;
  isLoading: boolean;
  validationError?: boolean;
}

export default function SubmitCard({
  totalPrice,
  isLoading,
  validationError,
}: SubmitCardProps) {
  // const [termChecked, setTermChecked] = useState(false);
  const searchParams = useSearchParams();

  const flightType = searchParams.get("flightType");

  const {
    title,
    termsAndconditions,
    termsAndconditionsRoundedTrips,
    submit,
    currency,
    price,
  } = staticData.submitInfo;

  return (
    <InfoCard
      header={{
        title,
        icon: <SealCheck weight="fill" className="w-5 h-5 text-secondary" />,
      }}
      defaultStyle={3}
    >
      <Flex className="w-full max-md:flex-col gap-y-4 justify-between p-6 pb-5">
        <Flex className="basis-1/2 items-center gap-x-2">
          <Typography className="text-balance">
            {flightType === "one-way"
              ? termsAndconditions
              : termsAndconditionsRoundedTrips}
          </Typography>
        </Flex>

        <Flex className="basis-1/2 gap-y-2 items-center justify-between gap-x-4">
          <Flex className="basis-1/2 items-center gap-x-2">
            <Typography variant="h6" className="text-primary font-normal">
              {price}
            </Typography>
            :
            <Typography variant="h6" className="text-primary font-medium">
              {totalPrice.toLocaleString()} {currency}
            </Typography>
          </Flex>

          <Button
            type="submit"
            className={cn(
              "basis-1/2 py-5 border-2 border-primary group bg-primary shadow-none",
              !isLoading && "hover:bg-background",
            )}
            disabled={isLoading}
          >
            {isLoading ? (
              <Pulse />
            ) : (
              <Typography
                variant="h6"
                className="font-semibold group-hover:text-primary"
              >
                {submit}
              </Typography>
            )}
          </Button>
        </Flex>
      </Flex>
    </InfoCard>
  );
}
